// Lista orașelor pentru pagini SEO pe țări
export type City = {
  slug: string;
  name: string;
  nameEn?: string;
  nameDe?: string;
  county?: string;
  region?: string;
  population?: number;
};

export const citiesRO: City[] = [
  // Top 30 orașe România pentru SEO
  { slug: 'bucuresti', name: 'București', county: 'București', population: 1883425 },
  { slug: 'cluj-napoca', name: 'Cluj-Napoca', county: 'Cluj', population: 324576 },
  { slug: 'timisoara', name: 'Timișoara', county: 'Timiș', population: 319279 },
  { slug: 'iasi', name: 'Iași', county: 'Iași', population: 290422 },
  { slug: 'constanta', name: 'Constanța', county: 'Constanța', population: 283872 },
  { slug: 'craiova', name: 'Craiova', county: 'Dolj', population: 269506 },
  { slug: 'brasov', name: 'Brașov', county: 'Brașov', population: 253200 },
  { slug: 'galati', name: 'Galați', county: 'Galați', population: 249432 },
  { slug: 'ploiesti', name: 'Ploiești', county: 'Prahova', population: 201226 },
  { slug: 'oradea', name: 'Oradea', county: 'Bihor', population: 196367 },
  { slug: 'braila', name: 'Brăila', county: 'Brăila', population: 180302 },
  { slug: 'arad', name: 'Arad', county: 'Arad', population: 159074 },
  { slug: 'pitesti', name: 'Pitești', county: 'Argeș', population: 155383 },
  { slug: 'sibiu', name: 'Sibiu', county: 'Sibiu', population: 147245 },
  { slug: 'bacau', name: 'Bacău', county: 'Bacău', population: 144307 },
  { slug: 'targu-mures', name: 'Târgu Mureș', county: 'Mureș', population: 134290 },
  { slug: 'baia-mare', name: 'Baia Mare', county: 'Maramureș', population: 123738 },
  { slug: 'buzau', name: 'Buzău', county: 'Buzău', population: 115494 },
  { slug: 'satu-mare', name: 'Satu Mare', county: 'Satu Mare', population: 102441 },
  { slug: 'botosani', name: 'Botoșani', county: 'Botoșani', population: 106847 },
  { slug: 'piatra-neamt', name: 'Piatra Neamț', county: 'Neamț', population: 85055 },
  { slug: 'drobeta-turnu-severin', name: 'Drobeta-Turnu Severin', county: 'Mehedinți', population: 92617 },
  { slug: 'suceava', name: 'Suceava', county: 'Suceava', population: 92121 },
  { slug: 'ramnicu-valcea', name: 'Râmnicu Vâlcea', county: 'Vâlcea', population: 107558 },
  { slug: 'targoviste', name: 'Târgoviște', county: 'Dâmbovița', population: 79610 },
  { slug: 'focsani', name: 'Focșani', county: 'Vrancea', population: 79315 },
  { slug: 'tulcea', name: 'Tulcea', county: 'Tulcea', population: 73707 },
  { slug: 'resita', name: 'Reșița', county: 'Caraș-Severin', population: 73282 },
  { slug: 'alba-iulia', name: 'Alba Iulia', county: 'Alba', population: 63536 },
  { slug: 'deva', name: 'Deva', county: 'Hunedoara', population: 61123 },
  { slug: 'vaslui', name: 'Vaslui', county: 'Vaslui', population: 55000 },
  { slug: 'alexandria', name: 'Alexandria', county: 'Teleorman', population: 50000 },
  { slug: 'slatina', name: 'Slatina', county: 'Olt', population: 70000 },
  { slug: 'sighisoara', name: 'Sighișoara', county: 'Mureș', population: 28100 },
];

export const citiesUK: City[] = [
  // Top 30 orașe UK pentru SEO
  { slug: 'london', name: 'London', nameEn: 'London', region: 'Greater London', population: 8982000 },
  { slug: 'birmingham', name: 'Birmingham', nameEn: 'Birmingham', region: 'West Midlands', population: 1141816 },
  { slug: 'manchester', name: 'Manchester', nameEn: 'Manchester', region: 'Greater Manchester', population: 547627 },
  { slug: 'glasgow', name: 'Glasgow', nameEn: 'Glasgow', region: 'Scotland', population: 633120 },
  { slug: 'liverpool', name: 'Liverpool', nameEn: 'Liverpool', region: 'Merseyside', population: 498042 },
  { slug: 'leeds', name: 'Leeds', nameEn: 'Leeds', region: 'West Yorkshire', population: 793139 },
  { slug: 'sheffield', name: 'Sheffield', nameEn: 'Sheffield', region: 'South Yorkshire', population: 584028 },
  { slug: 'edinburgh', name: 'Edinburgh', nameEn: 'Edinburgh', region: 'Scotland', population: 524930 },
  { slug: 'bristol', name: 'Bristol', nameEn: 'Bristol', region: 'South West', population: 463377 },
  { slug: 'newcastle', name: 'Newcastle', nameEn: 'Newcastle upon Tyne', region: 'Tyne and Wear', population: 302820 },
  { slug: 'cardiff', name: 'Cardiff', nameEn: 'Cardiff', region: 'Wales', population: 362756 },
  { slug: 'nottingham', name: 'Nottingham', nameEn: 'Nottingham', region: 'East Midlands', population: 321500 },
  { slug: 'leicester', name: 'Leicester', nameEn: 'Leicester', region: 'East Midlands', population: 354224 },
  { slug: 'coventry', name: 'Coventry', nameEn: 'Coventry', region: 'West Midlands', population: 345385 },
  { slug: 'southampton', name: 'Southampton', nameEn: 'Southampton', region: 'South East', population: 253651 },
  { slug: 'belfast', name: 'Belfast', nameEn: 'Belfast', region: 'Northern Ireland', population: 343542 },
  { slug: 'plymouth', name: 'Plymouth', nameEn: 'Plymouth', region: 'South West', population: 262100 },
  { slug: 'reading', name: 'Reading', nameEn: 'Reading', region: 'South East', population: 174224 },
  { slug: 'oxford', name: 'Oxford', nameEn: 'Oxford', region: 'South East', population: 152450 },
  { slug: 'cambridge', name: 'Cambridge', nameEn: 'Cambridge', region: 'East', population: 145818 },
  { slug: 'brighton', name: 'Brighton', nameEn: 'Brighton', region: 'South East', population: 290395 },
  { slug: 'york', name: 'York', nameEn: 'York', region: 'North Yorkshire', population: 210618 },
  { slug: 'exeter', name: 'Exeter', nameEn: 'Exeter', region: 'South West', population: 130698 },
  { slug: 'norwich', name: 'Norwich', nameEn: 'Norwich', region: 'East', population: 144000 },
  { slug: 'portsmouth', name: 'Portsmouth', nameEn: 'Portsmouth', region: 'South East', population: 205056 },
  { slug: 'derby', name: 'Derby', nameEn: 'Derby', region: 'East Midlands', population: 257174 },
  { slug: 'hull', name: 'Hull', nameEn: 'Kingston upon Hull', region: 'Yorkshire', population: 260645 },
  { slug: 'sunderland', name: 'Sunderland', nameEn: 'Sunderland', region: 'North East', population: 275506 },
  { slug: 'wolverhampton', name: 'Wolverhampton', nameEn: 'Wolverhampton', region: 'West Midlands', population: 263700 },
  { slug: 'aberdeen', name: 'Aberdeen', nameEn: 'Aberdeen', region: 'Scotland', population: 198590 },
];

export const citiesDE: City[] = [
  // Top 30 orașe Germania pentru SEO
  { slug: 'berlin', name: 'Berlin', nameDe: 'Berlin', region: 'Berlin', population: 3645000 },
  { slug: 'hamburg', name: 'Hamburg', nameDe: 'Hamburg', region: 'Hamburg', population: 1841000 },
  { slug: 'munchen', name: 'München', nameDe: 'München', region: 'Bayern', population: 1472000 },
  { slug: 'koln', name: 'Köln', nameDe: 'Köln', region: 'Nordrhein-Westfalen', population: 1086000 },
  { slug: 'frankfurt', name: 'Frankfurt', nameDe: 'Frankfurt am Main', region: 'Hessen', population: 753056 },
  { slug: 'stuttgart', name: 'Stuttgart', nameDe: 'Stuttgart', region: 'Baden-Württemberg', population: 634830 },
  { slug: 'dusseldorf', name: 'Düsseldorf', nameDe: 'Düsseldorf', region: 'Nordrhein-Westfalen', population: 621877 },
  { slug: 'dortmund', name: 'Dortmund', nameDe: 'Dortmund', region: 'Nordrhein-Westfalen', population: 587010 },
  { slug: 'essen', name: 'Essen', nameDe: 'Essen', region: 'Nordrhein-Westfalen', population: 582760 },
  { slug: 'leipzig', name: 'Leipzig', nameDe: 'Leipzig', region: 'Sachsen', population: 593145 },
  { slug: 'bremen', name: 'Bremen', nameDe: 'Bremen', region: 'Bremen', population: 569396 },
  { slug: 'dresden', name: 'Dresden', nameDe: 'Dresden', region: 'Sachsen', population: 556780 },
  { slug: 'hannover', name: 'Hannover', nameDe: 'Hannover', region: 'Niedersachsen', population: 535932 },
  { slug: 'nurnberg', name: 'Nürnberg', nameDe: 'Nürnberg', region: 'Bayern', population: 518370 },
  { slug: 'duisburg', name: 'Duisburg', nameDe: 'Duisburg', region: 'Nordrhein-Westfalen', population: 498686 },
  { slug: 'bochum', name: 'Bochum', nameDe: 'Bochum', region: 'Nordrhein-Westfalen', population: 364628 },
  { slug: 'wuppertal', name: 'Wuppertal', nameDe: 'Wuppertal', region: 'Nordrhein-Westfalen', population: 355100 },
  { slug: 'bielefeld', name: 'Bielefeld', nameDe: 'Bielefeld', region: 'Nordrhein-Westfalen', population: 334195 },
  { slug: 'bonn', name: 'Bonn', nameDe: 'Bonn', region: 'Nordrhein-Westfalen', population: 327258 },
  { slug: 'munster', name: 'Münster', nameDe: 'Münster', region: 'Nordrhein-Westfalen', population: 315293 },
  { slug: 'karlsruhe', name: 'Karlsruhe', nameDe: 'Karlsruhe', region: 'Baden-Württemberg', population: 308436 },
  { slug: 'mannheim', name: 'Mannheim', nameDe: 'Mannheim', region: 'Baden-Württemberg', population: 309370 },
  { slug: 'augsburg', name: 'Augsburg', nameDe: 'Augsburg', region: 'Bayern', population: 296582 },
  { slug: 'wiesbaden', name: 'Wiesbaden', nameDe: 'Wiesbaden', region: 'Hessen', population: 278474 },
  { slug: 'gelsenkirchen', name: 'Gelsenkirchen', nameDe: 'Gelsenkirchen', region: 'Nordrhein-Westfalen', population: 259645 },
  { slug: 'monchengladbach', name: 'Mönchengladbach', nameDe: 'Mönchengladbach', region: 'Nordrhein-Westfalen', population: 261454 },
  { slug: 'braunschweig', name: 'Braunschweig', nameDe: 'Braunschweig', region: 'Niedersachsen', population: 249406 },
  { slug: 'kiel', name: 'Kiel', nameDe: 'Kiel', region: 'Schleswig-Holstein', population: 246306 },
  { slug: 'aachen', name: 'Aachen', nameDe: 'Aachen', region: 'Nordrhein-Westfalen', population: 248960 },
  { slug: 'chemnitz', name: 'Chemnitz', nameDe: 'Chemnitz', region: 'Sachsen', population: 243880 },
];

export const getCityBySlug = (slug: string, country: 'RO' | 'UK' | 'DE'): City | undefined => {
  const cities = country === 'RO' ? citiesRO : country === 'UK' ? citiesUK : citiesDE;
  return cities.find(city => city.slug === slug);
};

export const getAllCities = (country: 'RO' | 'UK' | 'DE'): City[] => {
  return country === 'RO' ? citiesRO : country === 'UK' ? citiesUK : citiesDE;
};
